export function customRound(number = 0) {
    try {
        let result = number;
        const strNumber = number.toString();
        const decimalPlaces = strNumber.includes('.') ? strNumber.split('.')[1].length : 0;
        for (let i = decimalPlaces - 1; i >= 2; i--) {
            if (i >= 0) {
                result = Math.round(result.toFixed(i) * 100) / 100
            }
        }
        return Number(parseFloat(result)).toFixed(2);
    } catch (error) {
        return Number(parseFloat(number)).toFixed(2);
    }
}
